export default __webpack_public_path__ + "57dac989e2992b9725680e7b3ca1e514.png";